// Module
var code = "<react-component name=\"EditEmailDomain\" props=\"{gymId: gym.id, gymName: gym.name}\"></react-component>\n";
// Exports
module.exports = code;